export const PHASE4A_SOURCE_ATTRIBUTES = new Set([
    'phase2a.popup.0.anger',
    'phase2a.popup.0.biasandhate',
    'phase2a.popup.0.emotionopen',
    'phase2a.popup.0.emotionother',
    'phase2a.popup.0.empathy',
    'phase2a.popup.0.fear',
    'phase2a.popup.0.feartype',
    'phase2a.popup.0.formality',
    'phase2a.popup.0.offensiveness',
    'phase2a.popup.0.respectful',
    'phase2a.popup.0.threatening',
    'phase2a.popup.0.warmth',
    'phase2a.popup.1.anger',
    'phase2a.popup.1.biasandhate',
    'phase2a.popup.1.emotionopen',
    'phase2a.popup.1.emotionother',
    'phase2a.popup.1.empathy',
    'phase2a.popup.1.fear',
    'phase2a.popup.1.feartype',
    'phase2a.popup.1.formality',
    'phase2a.popup.1.offensiveness',
    'phase2a.popup.1.respectful',
    'phase2a.popup.1.threatening',
    'phase2a.popup.1.warmth',
    'phase2a.popup.2.anger',
    'phase2a.popup.2.biasandhate',
    'phase2a.popup.2.emotionopen',
    'phase2a.popup.2.emotionother',
    'phase2a.popup.2.empathy',
    'phase2a.popup.2.fear',
    'phase2a.popup.2.feartype',
    'phase2a.popup.2.offensiveness',
    'phase2a.popup.2.respectful',
    'phase2a.popup.2.threatening',
    'phase2a.popup.2.warmth',
    'phase2a.sidebar.acknowledgefault',
    'phase2a.sidebar.additionalarrive',
    'phase2a.sidebar.additionaltype',
    'phase2a.sidebar.additionalunits',
    'phase2a.sidebar.allegemisconduct',
    'phase2a.sidebar.allegeresponse',
    'phase2a.sidebar.allegetype',
    'phase2a.sidebar.allegetypeother',
    'phase2a.sidebar.anxiousapproach',
    'phase2a.sidebar.apologyciv',
    'phase2a.sidebar.apologyoff',
    'phase2a.sidebar.arrest',
    'phase2a.sidebar.askregistration',
    'phase2a.sidebar.background',
    'phase2a.sidebar.backgroundtype',
    'phase2a.sidebar.backup',
    'phase2a.sidebar.cameramuffle',
    'phase2a.sidebar.cameratap',
    'phase2a.sidebar.cartouch',
    'phase2a.sidebar.cellphone',
    'phase2a.sidebar.cellphoneuse',
    'phase2a.sidebar.challengeappropriateness',
    'phase2a.sidebar.citation',
    'phase2a.sidebar.citation_open',
    'phase2a.sidebar.clarity',
    'phase2a.sidebar.clarity2',
    'phase2a.sidebar.complaint',
    'phase2a.sidebar.compliment',
    'phase2a.sidebar.concernforsafety',
    'phase2a.sidebar.contrabandfoundpatdown',
    'phase2a.sidebar.contrabandfoundperson',
    'phase2a.sidebar.contrabandfoundvehicle',
    'phase2a.sidebar.contrabandseizedpatdown',
    'phase2a.sidebar.contrabandseizedperson',
    'phase2a.sidebar.contrabandseizedvehicle',
    'phase2a.sidebar.contrabandtypepatdown',
    'phase2a.sidebar.contrabandtypeperson',
    'phase2a.sidebar.contrabandtypevehicle',
    'phase2a.sidebar.deflection',
    'phase2a.sidebar.dephomesec',
    'phase2a.sidebar.detailaskoff',
    'phase2a.sidebar.detain',
    'phase2a.sidebar.detaintype',
    'phase2a.sidebar.duiask',
    'phase2a.sidebar.endpositive',
    'phase2a.sidebar.enforcementcomprehensioncheck',
    'phase2a.sidebar.force',
    'phase2a.sidebar.forcetype',
    'phase2a.sidebar.freetoleave',
    'phase2a.sidebar.greeting',
    'phase2a.sidebar.handcuff',
    'phase2a.sidebar.hands',
    'phase2a.sidebar.handswheel',
    'phase2a.sidebar.hatespeech',
    'phase2a.sidebar.hatespeech2',
    'phase2a.sidebar.hatespeechopen',
    'phase2a.sidebar.hatespeechopen2',
    'phase2a.sidebar.highriskpullover',
    'phase2a.sidebar.ifspeedinga',
    'phase2a.sidebar.ifspeedingb',
    'phase2a.sidebar.ifspeedingc',
    'phase2a.sidebar.impound',
    'phase2a.sidebar.interrupt',
    'phase2a.sidebar.interrupt2',
    'phase2a.sidebar.introducedept',
    'phase2a.sidebar.introducename',
    'phase2a.sidebar.investigationask',
    'phase2a.sidebar.investigationhelp',
    'phase2a.sidebar.investigationopen',
    'phase2a.sidebar.justification',
    'phase2a.sidebar.leavevehicle',
    'phase2a.sidebar.leavevehicleagainst',
    'phase2a.sidebar.legalcounsel',
    'phase2a.sidebar.movementcomply',
    'phase2a.sidebar.movementdirections',
    'phase2a.sidebar.movements',
    'phase2a.sidebar.movementscommunication',
    'phase2a.sidebar.officerforce',
    'phase2a.sidebar.officerforcetype',
    'phase2a.sidebar.officerthreatenviolence',
    'phase2a.sidebar.officerviolencefollowup',
    'phase2a.sidebar.options',
    'phase2a.sidebar.outofplace',
    'phase2a.sidebar.paroleask',
    'phase2a.sidebar.paroleprobation',
    'phase2a.sidebar.patdown',
    'phase2a.sidebar.patdownask',
    'phase2a.sidebar.patdownpermission',
    'phase2a.sidebar.patdownpermissionexplicit',
    'phase2a.sidebar.patdownpermissionfree',
    'phase2a.sidebar.perspectiveonleadup',
    'phase2a.sidebar.prior',
    'phase2a.sidebar.priorlegalreason',
    'phase2a.sidebar.priorsuspicion',
    'phase2a.sidebar.priorsuspicionreason',
    'phase2a.sidebar.providedl',
    'phase2a.sidebar.provideregistration',
    'phase2a.sidebar.psychold',
    'phase2a.sidebar.publicsafetyobject',
    'phase2a.sidebar.pullsafely',
    'phase2a.sidebar.reasonask',
    'phase2a.sidebar.reasoncare',
    'phase2a.sidebar.reasoncarequalifier',
    'phase2a.sidebar.reasoncivilianspecific',
    'phase2a.sidebar.reasongiven',
    'phase2a.sidebar.reasonofficerintent',
    'phase2a.sidebar.reasonprompt',
    'phase2a.sidebar.reasonspecific',
    'phase2a.sidebar.reasontype',
    'phase2a.sidebar.resist',
    'phase2a.sidebar.resisttype',
    'phase2a.sidebar.searchask',
    'phase2a.sidebar.searchpermfree',
    'phase2a.sidebar.searchpermission',
    'phase2a.sidebar.searchpermissionexplicit',
    'phase2a.sidebar.searchperson',
    'phase2a.sidebar.searchpersonask',
    'phase2a.sidebar.searchpersonpermfree',
    'phase2a.sidebar.searchpersonpermission',
    'phase2a.sidebar.searchpersonpermissionexplicit',
    'phase2a.sidebar.searchvehicle',
    'phase2a.sidebar.sobrietytest',
    'phase2a.sidebar.stateexactwarning/citation',
    'phase2a.sidebar.stepoutask',
    'phase2a.sidebar.stopcomprehensioncheck',
    'phase2a.sidebar.suspicionindicated',
    'phase2a.sidebar.suspicionopen',
    'phase2a.sidebar.thank',
    'phase2a.sidebar.thank2',
    'phase2a.sidebar.threatenviolence',
    'phase2a.sidebar.traffic',
    'phase2a.sidebar.verbalattack',
    'phase2a.sidebar.verbalattack2',
    'phase2a.sidebar.violencefollowup',
    'phase2a.sidebar.weaponask',
    'phase2a.sidebar.weapondrawn',
    'phase2a.sidebar.weaponinvehicle',
    'phase2a.sidebar.weapontype',
    'phase2a.sidebar.weapontype2',
    'phase2a.sidebar.weather',
    'phase2a.sidebar.yell',
    'phase2a.sidebar.yell2',
]);

export const PHASE4B_SOURCE_ATTRIBUTES = new Set([
    'phase2b.popup.recurring.respect',
    'phase2b.popup.0.overallrespect',
    'phase2b.popup.0.overallrespectopen',
    'phase2b.popup.0.objectivesummary',
    'phase2b.popup.0.subjectivesummary',
    'phase2b.popup.0.legitimacy',
    'phase2b.popup.0.legitimacyopen',
    'phase2b.popup.0.danger',
    'phase2b.popup.0.metapdanger',
]);

export function isTranscriptReviewPhase(phase: string): boolean {
    return ['phase4a', 'phase4b'].includes(phase);
}

export function sourceAttributesForTranscriptReviewPhase(phase: string): Set<string> {
    return phase === 'phase4a' ? PHASE4A_SOURCE_ATTRIBUTES : PHASE4B_SOURCE_ATTRIBUTES;
}

export function selectedQuestionDependencyIsAvailable(
    allowedAttributes: Set<string>,
    followupParent?: string | null,
): boolean {
    return !followupParent || allowedAttributes.has(followupParent);
}
